import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import {
  PaymentInclusionExclusionRulesResponseV1,
  PaymentRulesResponseV1,
} from '@arc/unified-payments-frontend/shared-payment';

export const PoiPadResultComponentPaymentRulesActions = createActionGroup({
  source: 'Pad Result Component Payment Rules',
  events: {
    'Load Payment Rules Success': props<{ payload: PaymentRulesResponseV1 }>(),
    'Load Payment Rules Error': props<{ payload: HttpErrorResponse }>(),
    'Load Inclusion Exclusion Rules Success': props<{
      payload: PaymentInclusionExclusionRulesResponseV1;
    }>(),
    'Load Inclusion Exclusion Rules Error': props<{
      payload: HttpErrorResponse;
    }>(),
  },
});
